import type { Template } from "@/types";

export const PO_06_H6_V0: Template[] = [
    {
        id: "po-06-h6v0-01",
        name: "PO 01 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 138, width: 593, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 564, width: 293, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 564, width: 292, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 760, y: 186, width: 541, height: 360, rotation: 0, imageRotation: 0 },
            { id: "5", x: 760, y: 553, width: 267, height: 178, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1034, y: 553, width: 267, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-02",
        name: "PO 02 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 138, width: 593, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 564, width: 293, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 564, width: 292, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 138, width: 593, height: 419, rotation: 0, imageRotation: 0 },
            { id: "5", x: 734, y: 564, width: 293, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 564, width: 292, height: 215, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-03",
        name: "PO 03 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 138, width: 593, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 564, width: 293, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 564, width: 292, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 137, width: 292, height: 215, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1034, y: 137, width: 293, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 734, y: 360, width: 593, height: 419, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-04",
        name: "PO 04 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 156, y: 80, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "2", x: 156, y: 335, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "3", x: 156, y: 590, width: 375, height: 246, rotation: 0, imageRotation: 0 },
            { id: "4", x: 843, y: 80, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "5", x: 843, y: 335, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "6", x: 843, y: 590, width: 375, height: 246, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h6v0-05",
        name: "PO 05 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 308, y: 80, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "2", x: 308, y: 335, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "3", x: 308, y: 590, width: 375, height: 246, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 80, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "5", x: 691, y: 335, width: 375, height: 247, rotation: 0, imageRotation: 0 },
            { id: "6", x: 691, y: 590, width: 375, height: 246, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-06",
        name: "PO 06 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 117, y: 0, width: 453, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 117, y: 308, width: 453, height: 300, rotation: 0, imageRotation: 0 },
            { id: "3", x: 117, y: 616, width: 453, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 0, width: 453, height: 300, rotation: 0, imageRotation: 0 },
            { id: "5", x: 804, y: 308, width: 453, height: 300, rotation: 0, imageRotation: 0 },
            { id: "6", x: 804, y: 616, width: 453, height: 300, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h6v0-07",
        name: "PO 07 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 52, y: 218, width: 335, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 462, width: 335, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 394, y: 218, width: 698, height: 480, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1100, y: 218, width: 222, height: 155, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1100, y: 381, width: 222, height: 155, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1100, y: 544, width: 222, height: 154, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-08",
        name: "PO 08 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 51, y: 167, width: 419, height: 287, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 462, width: 419, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 478, y: 167, width: 419, height: 287, rotation: 0, imageRotation: 0 },
            { id: "4", x: 478, y: 462, width: 419, height: 287, rotation: 0, imageRotation: 0 },
            { id: "5", x: 905, y: 167, width: 418, height: 287, rotation: 0, imageRotation: 0 },
            { id: "6", x: 905, y: 462, width: 418, height: 287, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-09",
        name: "PO 09 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 185, width: 683, height: 546, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 185, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 370, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 555, width: 262, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 961, y: 185, width: 413, height: 269, rotation: 0, imageRotation: 0 },
            { id: "6", x: 961, y: 462, width: 413, height: 269, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-10",
        name: "PO 10 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 291, width: 453, height: 334, rotation: 0, imageRotation: 0 },
            { id: "3", x: 461, y: 291, width: 222, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 461, y: 462, width: 222, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 691, y: 291, width: 222, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 691, y: 462, width: 222, height: 163, rotation: 0, imageRotation: 0 },
            { id: "2", x: 921, y: 291, width: 453, height: 334, rotation: 0, imageRotation: 0 },
        ],
    },
];

